import {action, makeObservable, observable, runInAction} from 'mobx'
import {request} from '@/framework/network/request'
import customHistory from "@/framework/customHistory";
import {message} from "antd";

let timer: NodeJS.Timeout

export default class PayStore {
    loading: boolean
    orderId: String //订单id
    amount: String  //支付价格
    payUrl: String //支付地址
    tradeStateDesc: String //订单状态

    constructor() {
        makeObservable(this, {
            loading: observable,
            orderId: observable,
            amount: observable,
            payUrl: observable,
            tradeStateDesc: observable,

            wxCheckOrderState: action,
            wxNativePay: action,
            wxCloseOrder: action,
            initializationData: action,
        })
        this.loading = false
        this.orderId = ""
        this.amount = ""
        this.payUrl = ""
        this.tradeStateDesc = "创建订单中"
    }

    initializationData = (id: String, amount: String, payUrl: String, tradeStateDesc: String) => {
        runInAction(() => {
            this.loading = true
            if (id !== "0") {
                this.orderId = id
            }
            if (amount !== "0") {
                this.amount = amount
            }
            if (payUrl !== "0") {
                this.payUrl = payUrl
            }
            if (tradeStateDesc !== "0") {
                this.tradeStateDesc = tradeStateDesc
            }
        })
        runInAction(() => {
            this.loading = false
        })
    }


    /**
     * 微信支付下单
     */
    wxNativePay = async (orderId: String) => {
        runInAction(() => {
            this.loading = true
        })
        if (this.orderId !== "") {
            const res = await request.get(`/pay/wxNativePay`, {orderId})
            if (res && res.status === 1) {
                if (res.data === 'SUCCESS') {
                    customHistory.push(`/payResult`)
                } else {
                    this.initializationData("0", "0", res.data, "订单未支付")
                    // this.tradeStateDesc = "订单未支付"
                    this.timerStart()
                }
            } else {
                message.error('网络错误！请重新加载该页面！')
            }
        }
        runInAction(() => {
            this.loading = false
        })
    }

    /**
     * 微信支付查单
     */
    wxCheckOrderState = async (orderId: String) => {
        runInAction(() => {
            this.loading = true
        })

        if (this.orderId && this.amount && this.payUrl !== "") {
            const res = await request.get(`/pay/wxCheckOrderState`, {orderId})
            if (res.data) {
                let data = JSON.parse(res.data)
                this.initializationData("0", "0", "0", data.trade_state_desc)
                // this.tradeStateDesc = data.trade_state_desc
                if (data.trade_state === "SUCCESS") {
                    clearInterval(timer)
                    customHistory.push(`/payResult`)
                }
            }
        }
        runInAction(() => {
            this.loading = false
        })
    }

    /**
     * 微信支付关单
     */
    wxCloseOrder = async (orderId: String) => {
        runInAction(() => {
            this.loading = true
        })
        console.log(orderId)
        // this.payUrl = ""
        // console.log(1111)
        // if (this.orderPayId ) {
        //   console.log(22222)
        //   // const res = await request.get(`/pay/wxCloseOrder`, {orderId})
        //   // console.log(res)
        // }
        // console.log(3333)
        // runInAction(() => {
        //   this.loading = false
        // })
    }
    timerStart = () => {
        let num = 0;
        timer = setInterval(() => {
            this.wxCheckOrderState(this.orderId)
            num++
            if (num > 180) {
                clearInterval(timer)
                // this.wxCloseOrder(this.orderPayId)
            }
        }, 2000);
    }

}
